<template>
  <Dashboard grafana-path="/d/DURPxduMz/shift" />
</template>

<script>
// @ is an alias to /src
import Dashboard from "@/components/Dashboard.vue";

export default {
  name: "ShiftPage",

  routing: {
    localizationKey: "menu.tab.shift",
    icon: "mdi-table",
    path: "/shift",
    hasAccess: (user) => user.isAdmin || user.isManager,
  },

  components: {
    Dashboard,
  },
};
</script>
